module.exports = __webpack_public_path__ + "img/ball_3.dbd11343.png";